import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';

import Field from '@/components/fields/Field';
import OrganizationDropdownSelect from '@/views/fields/OrganizationDropdownSelect/OrganizationDropdownSelect';
import RoleDropdownSelect from '@/views/fields/RoleDropdownSelect/RoleDropdownSelect';

import { UserSectionHiddenFields } from './constants';
import DropdownSection from './DropdownSection';

interface SectionUserProps {
  name: string;
  hiddenFields?: Set<UserSectionHiddenFields>;
}

const SectionUser: FC<SectionUserProps> = props => {
  const { t } = useTranslation('filters');
  const { name, hiddenFields = new Set<UserSectionHiddenFields>() } = props;

  const isOrganizationShown = !hiddenFields.has(UserSectionHiddenFields.ORGANIZATION);
  const isRoleShown = !hiddenFields.has(UserSectionHiddenFields.ROLE);

  return (
    <DropdownSection title={t('filters.sections.user.title')} {...props}>
      {isOrganizationShown && (
        <>
          <Field
            component={OrganizationDropdownSelect}
            name={`${name}.organization`}
            label={t('filters.sections.user.organization')}
            innerProps={{
              isMulti: false,
              isClearable: true,
              usePortal: true
            }}
            withFormControl
          />
        </>
      )}
      {isOrganizationShown && isRoleShown && <Divider />}
      {isRoleShown && (
        <>
          <Field
            component={RoleDropdownSelect}
            name={`${name}.role`}
            label={t('filters.sections.user.role')}
            withFormControl
            innerProps={{
              usePortal: true,
              isMulti: false
            }}
          />
        </>
      )}
    </DropdownSection>
  );
};

export default SectionUser;
